// Persistent brand bar used in every top-level header (shell, delivery,
// migration unit). Layout: [ArcPilot mark]  ArcPilot  ·  by [DreamDev]
//   - The ArcPilot gradient mark anchors the product identity.
//   - The "by DreamDev" lockup attributes the corporate parent and is
//     hidden on narrow headers via `compact`.
// Clicking the bar routes home — a consistent escape hatch back to the
// landing page from any view.
import React from 'react';
import { Link } from 'react-router-dom';
import ArcPilotLogo from './ArcPilotLogo';
import DreamDevLogo from './DreamDevLogo';

interface Props {
  linkTo?: string;
  // Hide the "by DreamDev" lockup on narrow headers. The ArcPilot mark
  // + name stay visible.
  compact?: boolean;
}

const AppBrand: React.FC<Props> = ({ linkTo = '/', compact = false }) => (
  <Link to={linkTo} className="app-brand" aria-label="ArcPilot home">
    <ArcPilotLogo variant="dark" height={24} className="app-brand-mark" />
    <span className="app-brand-name">ArcPilot</span>
    {!compact && (
      <>
        <span className="app-brand-by">by</span>
        <DreamDevLogo
          variant="lockup"
          height={12}
          color="var(--dd-brand)"
          className="app-brand-lockup"
        />
      </>
    )}
  </Link>
);

export default AppBrand;
